import React from 'react';
import { Text, Button, ButtonPriority } from '@wix/wix-ui-tpa/cssVars';

import { classes, st } from './OrderNow.st.css';
import { useHooks } from './useHooks';

export type OrderNowProps = {};

const OrderNow: React.FC<OrderNowProps> = () => {
  const { t, layoutSize, handleClick } = useHooks();

  return (
    <div className={st(classes.root, { [layoutSize]: true })}>
      <div className={st(classes.wrapper)}>
        <div className={st(classes.content)}>
          <Text tagName="p">{t('header_olo.multiLocationNotification')}</Text>
          <Button priority={ButtonPriority.primary} onClick={handleClick}>
            {t('header_olo.startOrderButton')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrderNow;
